const GENIUS_URL = "https://sistemasgenius.com";

export default function AppFooter({ className = "" }) {
  return (
    <footer className={`app-footer${className ? ` ${className}` : ""}`}>
      <a href={GENIUS_URL} target="_blank" rel="noreferrer">
        DESAROLLADO POR GENIUS SOFTWARE S.A.S V1
      </a>
    </footer>
  );
}
